<script lang="ts">
  import Drawer, { AppContent } from '@smui/drawer';
  import { setContext } from 'svelte';

  import Leaflet from './Leaflet.svelte';
  import NavBar from './NavBar.svelte';
  import Sidenav from './sidenav/Sidenav.svelte';

  let leaflet;
  let windowWidth: number;
  let drawerOpen = true;
  $: {
    // auto-close drawer on narrow screens
    drawerOpen = !(windowWidth < 800);
  }

  setContext('leaflet', {
    getLeaflet: () => leaflet,
  });
  setContext('drawer', {
    toggleDrawer: () => (drawerOpen = !drawerOpen),
  });
</script>

<NavBar />
<div class="body-container">
  <Drawer variant="dismissible" bind:open={drawerOpen} style="width: 400px">
    <Sidenav />
  </Drawer>
  <AppContent class="app-content">
    <Leaflet bind:this={leaflet} />
  </AppContent>
</div>
<svelte:window bind:innerWidth={windowWidth} />

<style lang="scss">
  @use 'src/styles/variables' as vars;

  .body-container {
    width: 100vw;
    height: calc(100vh - #{vars.$nav-height});
    position: fixed;
    top: vars.$nav-height;
    z-index: 0;
    display: flex;
  }

  * :global(.app-content) {
    flex: auto;
    overflow: auto;
    position: relative;
    flex-grow: 1;
  }

  * :global(.mdc-drawer.mdc-drawer--open:not(.mdc-drawer--closing) + .mdc-drawer-app-content) {
    margin-left: 400px;
  }
</style>
